import React from "react";
import { eventEmitter } from "../../services";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { COLORS, TYPE_INFO } from "../ui/Colors";
import { NOTIFICATION_SET, NOTIFICATION_CLEAR } from "../dialogs/Notification";

const Wrapper = styled.div<{
    margin?: string;
    type: string;
}>`
    width: 100%;
    font-size: 14px;
    margin: ${(p) => p.margin || "20px 0 40px 0"};
    padding: 10px 15px;
    border-radius: 2px;
    border: 1px solid ${(p) => COLORS[p.type]["borderColor"]};
    background-color: ${(p) => COLORS[p.type]["backgroundColor"]};
    color: ${(p) => COLORS[p.type]["color"]};
    text-align: center;
`;

interface NotificationProps {
    margin?: string;
}
interface NotificationState {
    type: string;
    messageId: string;
}
export class Notification extends React.Component<
    NotificationProps,
    NotificationState
> {
    constructor(props: NotificationProps) {
        super(props);
        this.state = {
            type: TYPE_INFO,
            messageId: "",
        };
    }

    onNotificationSet = ({ type, messageId }: NotificationState) =>
        this.setState({ type, messageId });

    onNotificationClear = () =>
        this.setState({
            type: TYPE_INFO,
            messageId: "",
        });

    componentDidMount() {
        eventEmitter.on(NOTIFICATION_SET, this.onNotificationSet);
        eventEmitter.on(NOTIFICATION_CLEAR, this.onNotificationClear);
    }

    componentWillUnmount() {
        eventEmitter.off(NOTIFICATION_SET, this.onNotificationSet);
        eventEmitter.off(NOTIFICATION_CLEAR, this.onNotificationClear);
    }

    render() {
        const { type, messageId } = this.state;
        if (
            !messageId ||
            (typeof messageId === "string" && messageId.length === 0)
        ) {
            return null;
        }

        const { margin } = this.props;
        return (
            <Wrapper type={type || TYPE_INFO} margin={margin}>
                <FormattedMessage id={messageId} />
            </Wrapper>
        );
    }
}
